import { reportError, toErrorString } from "../utils/errorLogger";

export const getBrowserDetails = async () => {
    let ip = null;
    await fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => (ip = data.ip))
        .catch(error => {
            const userName = localStorage.getItem('UserName');
            const errorStr = toErrorString(error || error.message);
            reportError({
                endpoint: 'https://api.ipify.org?format=jso',
                message: String(error.message || 'Unhandled error'),
                error: errorStr,
                userName: userName || '',
                level: 'warn',
            });
            console.error('Error fetching IP address:', error)
        });
    const details = {
        appVersion: navigator.appVersion,
        platform: navigator.platform,
        ip: ip
    };
    return JSON.stringify(details);
};